import { DIRECTION } from '../configs';

export default function getDefaultSort(columns = [], direction = DIRECTION.DESC) {
  if (Array.isArray(columns) && columns.length) {
    const column = columns.find(item => item.defaultSort);
    const sortField = column?.sortField || column?.dataField || '';
    return sortField ? `${direction}${sortField}` : '';
  }
  return '';
}
